// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/store.js";
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import {description} from '../package.json'

Vue.use(ElementUI);
Vue.use(VueMoment, {
  moment,
});
//启动时的生产提示
Vue.config.productionTip = false;
// axios
import axios from "axios";
import Qs from "qs";
axios.defaults.transformRequest = [function (data) {
  if (data.toString() == "[object FormData]") {
    return data;
  } else {
    return Qs.stringify(data)
  }
}];
let initApp = function () {

  const instance = axios.create({
    baseURL: localStorage.lineUrl,
    timeout: 10000,
    withCredentials: true
  });
  Vue.prototype.$http = instance;

  sessionStorage.removeItem('lineUrl')
  /**
   * wonder chat system start
   */
  const wonderChatInstace = axios.create({
    baseURL: process.env.WONDER_CHAT_ROOT,
    timeout: 10000,
    withCredentials: true
  });
  Vue.prototype.$wonderChat = wonderChatInstace;

  //end wonder chat system
  //Vue.prototype.$http = instance;

  //force logout and goto login
  Vue.prototype.$logout = function (msg) {
    this.$toast.fail(msg);
    setTimeout(() => {
      this.$store.commit("changeLoginType", false);
      sessionStorage.setItem("token", "");
      localStorage.clear();
      this.$router.push("/login");
      window.location.reload();
    }, 2000);
  };

  // Common loader
  Vue.prototype.$NoNetworkErrorMsg = "网络连接失败,稍后再试";
  // Vue.prototype.$ShowCommonLoading = function () {
  //   return this.$toast.loading({
  //     duration: 0, // 持续展示 toast
  //     forbidClick: true,
  //     overlay: true,
  //     message: "加载中...",
  //   });
  // };
  // const host = process.env.NODE_ENV === "development" ? "/" : "https://server.hk9999z.com/"; // 根据 process.env.NODE_ENV 的值判断当前是什么环境
  // const instance = axios.create({
  //   baseURL: host,
  //   timeout: 10000,
  //   withCredentials: true
  // });
  // Vue.prototype.$http = instance;
  // 添
  /* eslint-disable no-new */

  Vue.prototype.$LoadFromDomain = process.env.LOAD_FROM_DOMAIN;
  Vue.prototype.$AutoLogin = process.env.AUTO_LOGIN;
  Vue.prototype.$DownloadPopup = process.env.DOWNLOAD_POPUP;

  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  });

  router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
  });
}

Vue.prototype.$chatApiURL = process.env.WONDER_CHAT_ROOT;

let Line_1 = process.env.Line_1;//"https://server3299.hk99666.com/";
let Line_2 = process.env.Line_2;//"https://server3299.hk99111.com/";

Vue.prototype.$URLs = [{ "id": 1, "name": "线路一", "url": process.env.API_ROOT }, { "id": 2, "name": "线路二", "url": Line_1 }, { "id": 3, "name": "线路三", "url": Line_2 }];
let lines = Vue.prototype.$URLs;

let workingLines = [];

let checkLine = function (url) {
  return new Promise((resolve, reject) => {
    if(url === null || url === undefined){reject();return;};
    fetch(url, { mode: 'no-cors' })
      .then(response => {
        resolve();
      })
      .catch(error => {
        reject();
      });
  });
}

let lineSelectPromise = new Promise((resolve, reject) => {
  lines.forEach((value, index, array) => {
    let startTime = new Date().getTime();
    fetch(value.url, { mode: 'no-cors' })
      .then(response => {
        let endTime = new Date().getTime();
        let elapsedTime = endTime - startTime;
        let item = {};
        item.time = elapsedTime;
        item.url = value.url;
        item.name=value.name;
        item.id=value.id;

        workingLines.push(item);
        if (index === array.length - 1 || workingLines.length > 1) resolve();

      })
      .catch(error => {
        if (index === array.length - 1) resolve();
      });
  })
})

const urlParams = new URLSearchParams(window.location.hash.split('?')[1])
const paramValue = urlParams.get('line')
if(paramValue){
if(paramValue=="api1"){
      sessionStorage.setItem('lineUrl',process.env.API_ROOT);
      localStorage.setItem('lineUrl',process.env.API_ROOT);
      localStorage.setItem('lineUrlText', lines[0].name);
      sessionStorage.setItem('lineUrlText',lines[0].name);
      localStorage.setItem('lineUrlId', lines[0].id);
      sessionStorage.setItem('lineUrlId',lines[0].id);
      
}
else if(paramValue=="api2"){
  lineSelectPromise.then(res => {
    const status = workingLines.some(item => item.url == Line_1);
    const newLineUrl = status==true ? Line_1 : process.env.API_ROOT;
    const newLineText= status==true ? lines[1].name : lines[0].name;
    const newLineId= status==true ? lines[1].id : lines[0].id;

    localStorage.setItem('lineUrl', newLineUrl);
    sessionStorage.setItem('lineUrl', newLineUrl);
    localStorage.setItem('lineUrlText', newLineText);
    sessionStorage.setItem('lineUrlText',newLineText);
    localStorage.setItem('lineUrlId', newLineId);
    sessionStorage.setItem('lineUrlId',newLineId);
//reload once
    if (localStorage.getItem('reloaded')) {
      localStorage.removeItem('reloaded');
    } else {
      localStorage.setItem('reloaded', '1');
      location.reload();
    }
    
});

}
else if(paramValue=="api3"){
  lineSelectPromise.then(res => {
    const status = workingLines.some(item => item.url == Line_2);
    const newLineUrl = status==true ? Line_2 : process.env.API_ROOT;
    const newLineText= status==true ? lines[2].name : lines[0].name;
    const newLineId= status==true ? lines[2].id : lines[0].id;

    localStorage.setItem('lineUrl', newLineUrl);
    sessionStorage.setItem('lineUrl', newLineUrl);
    localStorage.setItem('lineUrlText', newLineText);
    sessionStorage.setItem('lineUrlText',newLineText);
    localStorage.setItem('lineUrlId', newLineId);
    sessionStorage.setItem('lineUrlId',newLineId);
     //reload once
   if (localStorage.getItem('reloaded')) {
      localStorage.removeItem('reloaded');
    } else {
      localStorage.setItem('reloaded', '1');
      location.reload();
    }
});

}
  // }
  initApp();

}

  else{
//continue with current api line if it's working
let storedLine = sessionStorage.lineUrl;
checkLine(storedLine).then(() => {
  initApp();
}).catch(() => {
  lineSelectPromise.then(res => {

    workingLines.sort((a, b) => (a.time > b.time) ? 1 : -1)
    let lineURL = workingLines.length > 0 ? workingLines[0].url : process.env.API_ROOT;
    let lineURLText = workingLines.length > 0 ? workingLines[0].name : lines[0].name;
    let lineUrlId = workingLines.length > 0 ? workingLines[0].id : lines[0].id;

    if (lineURL) {
      localStorage.setItem('lineUrl', lineURL);
      sessionStorage.setItem('lineUrl',lineURL);
      localStorage.setItem('lineUrlText', lineURLText);
      sessionStorage.setItem('lineUrlText',lineURLText);
      localStorage.setItem('lineUrlId', lineUrlId);
      sessionStorage.setItem('lineUrlId',lineUrlId);
    } else {
      localStorage.setItem('lineUrl',process.env.API_ROOT);
      sessionStorage.setItem('lineUrl',process.env.API_ROOT);
      localStorage.setItem('lineUrlText', lines[0].name);
      sessionStorage.setItem('lineUrlText',lines[0].name);
      localStorage.setItem('lineUrlId', lines[0].id);
      sessionStorage.setItem('lineUrlId',lines[0].id);
    }
    initApp();
  })
})
  }


// WEBPACK FOOTER //
// ./src/main.js